import { z } from 'zod';

export const shipmentGroupMasterSchema = z.object({
  shipmentGroupId: z.string().uuid('Invalid shipment group ID'),
  name: z.string().min(1, 'Name is required'),
  contactId: z.string().uuid('Invalid contact ID'),
  billIncubator: z.boolean().optional(),
  shippingMethod: z.number().optional(),
  shipComment: z.string().optional(),
  callTagComment: z.string().optional(),
  billShipping: z.boolean().optional(),
  siteId: z.string().uuid('Invalid site ID').optional(),
  callTagContactId: z.string().uuid('Invalid call tag contact ID').optional(),
  comment: z.string().optional(),
});

export type ShipmentGroupMasterFormData = z.infer<
  typeof shipmentGroupMasterSchema
>;
